<template>
   <div class="mheader" :class="{'dark':themeName=='dark'}" ><slot></slot><div class="rightcss">			<select id="s1" class="ctusel" @change='tudx'>
				<option select="selected">图片大小</option>
				 <option  value="2" >自适应</option> 
				<option  value="1" >100%</option> 
				<option value="0.9" >90%</option> 
				<option value="0.8" >80%</option> 
				<option value="0.7" >70%</option> 
				<option value="0.6" >60%</option>
				 <option value="0.5" >50%</option> 
				 <option value="0.4" >40%</option> 
				 <option value="0.3" >30%</option>
				 <option value="0.2" >20%</option>
				 <option value="0.1" >10%</option>
</select></div></div>
</template>
<script>
	 
export default {
  name: 'Headertu',
  	methods: {
		tudx(){
			
			var va = document.getElementById("s1").value;
			var tuva = 900*va ;
			if(va ==2){
				document.querySelector('#zhutu').style.width='100%';
			}else{
	document.querySelector('#zhutu').style.width=tuva+'px';}
		}
		}
}
</script>
